import { useLang } from '@/pages/home/context/LanguageContext';

const pillarsPT = [
  { icon: 'ri-shield-check-line', title: 'Segurança Industrial', desc: 'Todos os nossos serviços são executados seguindo rigorosos protocolos de segurança industrial, garantindo a proteção dos trabalhadores e das instalações.', color: 'bg-[#0B1A35]', textColor: 'text-white', subColor: 'text-white/60' },
  { icon: 'ri-award-line', title: 'Padrão de Qualidade', desc: 'Processos certificados e metodologias comprovadas que asseguram resultados consistentes e de alta qualidade em cada projeto.', color: 'bg-[#F97316]', textColor: 'text-white', subColor: 'text-white/80' },
  { icon: 'ri-team-line', title: 'Equipa Especializada', desc: 'Técnicos com formação contínua, certificações internacionais e vasta experiência em ambientes industriais exigentes.', color: 'bg-[#F8F9FA]', textColor: 'text-[#0B1A35]', subColor: 'text-gray-500' },
  { icon: 'ri-timer-flash-line', title: 'Resposta Rápida', desc: 'Disponibilidade 24/7 para emergências técnicas, com tempos de resposta otimizados para minimizar paragens operacionais.', color: 'bg-[#F8F9FA]', textColor: 'text-[#0B1A35]', subColor: 'text-gray-500' },
  { icon: 'ri-user-settings-line', title: 'Soluções Personalizadas', desc: 'Cada cliente recebe um plano de manutenção adaptado às suas necessidades específicas, maximizando eficiência e reduzindo custos.', color: 'bg-[#F8F9FA]', textColor: 'text-[#0B1A35]', subColor: 'text-gray-500' },
  { icon: 'ri-bar-chart-line', title: 'Confiabilidade Operacional', desc: 'Foco em manutenção preventiva para garantir a máxima disponibilidade dos equipamentos e a continuidade das operações industriais.', color: 'bg-[#0B1A35]', textColor: 'text-white', subColor: 'text-white/60' },
];

const pillarsEN = [
  { icon: 'ri-shield-check-line', title: 'Industrial Safety', desc: 'All our services are carried out following rigorous industrial safety protocols, ensuring the protection of workers and facilities.', color: 'bg-[#0B1A35]', textColor: 'text-white', subColor: 'text-white/60' },
  { icon: 'ri-award-line', title: 'Quality Standard', desc: 'Certified processes and proven methodologies that ensure consistent, high-quality results on every project.', color: 'bg-[#F97316]', textColor: 'text-white', subColor: 'text-white/80' },
  { icon: 'ri-team-line', title: 'Specialized Team', desc: 'Technicians with continuous training, international certifications and extensive experience in demanding industrial environments.', color: 'bg-[#F8F9FA]', textColor: 'text-[#0B1A35]', subColor: 'text-gray-500' },
  { icon: 'ri-timer-flash-line', title: 'Fast Response', desc: '24/7 availability for technical emergencies, with optimized response times to minimize operational downtime.', color: 'bg-[#F8F9FA]', textColor: 'text-[#0B1A35]', subColor: 'text-gray-500' },
  { icon: 'ri-user-settings-line', title: 'Customized Solutions', desc: 'Each client receives a maintenance plan tailored to their specific needs, maximizing efficiency and reducing costs.', color: 'bg-[#F8F9FA]', textColor: 'text-[#0B1A35]', subColor: 'text-gray-500' },
  { icon: 'ri-bar-chart-line', title: 'Operational Reliability', desc: 'Focus on preventive maintenance to ensure maximum equipment availability and continuity of industrial operations.', color: 'bg-[#0B1A35]', textColor: 'text-white', subColor: 'text-white/60' },
];

const headingPT = {
  tag: 'Nossos diferenciais',
  title: 'Compromisso com a Qualidade',
  desc: 'A qualidade não é apenas uma promessa — é o fundamento de cada serviço que prestamos. Diferenciamo-nos pela excelência técnica e pelo compromisso com os resultados.',
  ctaTitle: 'Pronto para elevar a sua operação industrial?',
  ctaDesc: 'Contacte-nos hoje e descubra como a PAMIR pode ser o parceiro técnico estratégico que a sua empresa precisa.',
  ctaBtn: 'Solicitar Consultoria Técnica',
};

const headingEN = {
  tag: 'Our differentials',
  title: 'Commitment to Quality',
  desc: 'Quality is not just a promise — it is the foundation of every service we provide. We differentiate ourselves through technical excellence and commitment to results.',
  ctaTitle: 'Ready to elevate your industrial operation?',
  ctaDesc: 'Contact us today and discover how PAMIR can be the strategic technical partner your company needs.',
  ctaBtn: 'Request Technical Consulting',
};

export default function QualitySection() {
  const { lang } = useLang();
  const pillars = lang === 'PT' ? pillarsPT : pillarsEN;
  const h = lang === 'PT' ? headingPT : headingEN;

  return (
    <section id="quality" className="py-24 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#F97316] text-sm font-semibold uppercase tracking-widest">
            {h.tag}
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B1A35] mt-2">{h.title}</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto mt-4 leading-relaxed">{h.desc}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {pillars.map((p) => (
            <div
              key={p.title}
              className={`${p.color} rounded-2xl p-8 transition-transform duration-300 hover:-translate-y-1 cursor-default`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl mb-5">
                <i className={`${p.icon} text-2xl ${p.textColor}`}></i>
              </div>
              <h3 className={`font-bold text-lg mb-3 ${p.textColor}`}>{p.title}</h3>
              <p className={`text-sm leading-relaxed ${p.subColor}`}>{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="relative rounded-3xl overflow-hidden">
          <div className="w-full h-72 md:h-80">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_a5e9eec9e78dfa42fcf4802031476d6e_75933cd6.jpg"
              alt="Equipa PAMIR em ação"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B1A35]/90 via-[#0B1A35]/70 to-transparent flex items-center">
            <div className="px-10 md:px-16 max-w-xl">
              <h3 className="text-white text-3xl md:text-4xl font-extrabold mb-4 leading-tight">
                {h.ctaTitle}
              </h3>
              <p className="text-white/70 text-sm mb-8 leading-relaxed">{h.ctaDesc}</p>
              <a
                href="mailto:geral@pamir.ao"
                className="bg-[#F97316] hover:bg-[#ea6c0a] text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 w-fit"
              >
                {h.ctaBtn}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
